import { TextField, Box } from '@mui/material';
import { useGlobalStore } from '../../../application/store/store';

const Patient = () => {
    // Access patient data and the setter function from the global store
    const patientData = useGlobalStore((state) => state.patientData);
    const setPatientData = useGlobalStore((state) => state.setPatientData);

    // Handle input change and update global state
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPatientData({
            ...patientData,
            [name]: value.trim() === '' ? null : value,
        });
    };

    return (
        <Box sx={{ width: '100%', textAlign: 'center', px: { xs: 2, sm: 0 } }}>
            <TextField
                id="firstname"
                name="firstname"
                label="Förnamn"
                value={patientData.firstname || ''}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                aria-required="true"
                aria-label="Patient's first name"
                sx={{ mb: 2 }}
            />
            <TextField
                id="lastname"
                name="lastname"
                label="Efternamn"
                value={patientData.lastname || ''}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                aria-required="true"
                aria-label="Patient's last name"
                sx={{ mb: 2 }}
            />
            <TextField
                id="pnr"
                name="pnr"
                label="PatientID"
                value={patientData.pnr || ''}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                aria-required="true"
                aria-label="Patient's ID"
                aria-describedby="patientID-desc"
                sx={{ mb: 2 }}
            />
        </Box>
    );
};

export default Patient;
